import { useState } from 'react';
import { Banner } from '../Components';
import { handleDownload } from '../utils/globalFunctions';

const BuildingResources = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [downloadingUrl, setDownloadingUrl] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate a network request
    setTimeout(() => {
      if (password === 'builder') {
        setIsAuthenticated(true);
        setError('');
      } else {
        setError('Incorrect password. Please try again.');
      }
      setIsLoading(false);
    }, 500);
  };

  const handlePdfDownload = async (url) => {
    setDownloadingUrl(url);
    try {
      await handleDownload(url);
    } finally {
      // Keep the indicator visible for a brief moment before hiding
      setTimeout(() => setDownloadingUrl(null), 800);
    }
  };

  const ResourcesSection = ({ title, links }) => (
    <div className="p-6 rounded-lg mb-8 h-full w-full">
      <h3 className="text-2xl font-tobias font-semibold text-gableGreen mb-6 border-b border-gray-200">{title}</h3>
      <div className="mb-4">
        <div className="w-full h-[1px] bg-gray-500 rounded-full"></div>
      </div>
      <ul className="list-none pl-0 space-y-3">
        {links.map((link, index) => (
          <li key={index}>
            <div className="flex items-center gap-2">
              <a
                href={link.url}
                onClick={(e) => {
                  e.preventDefault();
                  handlePdfDownload(link.url);
                }}
                className="hover:underline hover:text-blue-800 transition-colors duration-200 flex-1"
              >
                {link.text}
              </a>
              {downloadingUrl === link.url && (
                <div className="flex items-center gap-1.5 text-gableGreen">
                  <svg
                    className="animate-spin h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  <span className="text-sm font-medium">Downloading...</span>
                </div>
              )}
            </div>
            {link.inlineLinks && link.inlineLinks.length > 0 && (
              <div className="mt-2 ml-4">
                <span className="text-gray-600 block mb-2">Lots:</span>
                <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-4 lg:grid-cols-5 gap-0">
                  {link.inlineLinks.map((inlineLink, inlineIndex) => (
                    <a
                      key={inlineIndex}
                      href={inlineLink.url}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePdfDownload(inlineLink.url);
                      }}
                      className="hover:underline hover:text-blue-800 transition-colors duration-200 text-center py-1 px-2 text-sm"
                    >
                      {inlineLink.text}
                    </a>
                  ))}
                </div>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  const buildingResources = [
    {
      title: "Stage One - Highfield Release One",
      links: [
        { text: "Design Guidelines (Stage 1A)", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/01_Design_Guidelines_Stage_1A.pdf" },
        { text: "Civil Design Drawing Set", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/02_Civil_Design_Drawing_Set.pdf" },
        { text: "Sales Plan (Stage 1A)", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/03_Sales_Plan_Stage_1A.pdf" },
        { text: "Plan of Subdivision (Stage 1A) - Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/04_Plan_of_Subdivision_Stage_1A_-_Plan.pdf" },
        { text: "Plan of Subdivision (Stage 1A) - Part 1 & 2", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/05_Plan_of_Subdivision_Stage_1A_-_Part_1_2.pdf" },
        { text: "Contour Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/06_Contour_Plan.pdf" },
        { text: "Disclosure Plans - Stage 1 Combined Plans", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/07_Disclosure_Plans_-_Stage_1_Combined_Plans.pdf" },
        { text: "Statement of Environmental Affects", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/08_Statement_of_Environmental_Affects.pdf" },
        { text: "Acoustics Report Sep 2016", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/09_Acoustics_Report_Sep_2016.pdf" },
        { text: "Bushfire Certifiers Threat Assessment Sept 2016", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/10_Bushfire_Certifiers_Threat_Assessment_Sept_2016.pdf" },
        { text: "Level 1 Geotechnical Inspection & Testing", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/11_Level_1_Geotechnical_Inspection_Testing.pdf" },
        { text: "Tank location update", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_One_-_Highfield_Release_One/12_Tank_location_update.pdf" }
      ]
    },
    {
      title: "Stage Two - Hilltop Release",
      links: [
        { text: "Design Guidelines", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/01_Design_Guidelines.pdf" },
        { text: "Stage Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/02_Stage_Plan.jpg" },
        { text: "Preliminary Earth Works Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/03_Preliminary_Earth_Works_Plan.pdf" },
        { text: "Disclosure Plans (Issue B)", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/04_Disclosure_Plans_Issue_B.pdf" },
        { text: "Acoustics Report Sep 2016", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/05_Acoustics_Report_Sep_2016.pdf" },
        { text: "Draft Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/06_Draft_Plan.pdf" },
        { text: "Stage 2 Geotechnical Level 1 Report", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/07_Stage_2_Geotechnical_Level_1_Report.pdf" },
        { text: "Neighbourhood Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/08_Neighbourhood_Plan.pdf" },
        { text: "As Constructed Drawings", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/09_As_Constructed_Drawings.pdf" },
        { text: "Registered Deposited Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/10_Registered_Deposited_Plan.pdf" },
        { text: "Detention Tank Engineering Drawings", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/11_Detention_Tank_Engineering_Drawings.pdf" },
        { text: "Letter of Advice", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Two_-_Hilltop_Release/12_Letter_of_Advice.pdf" }
      ]
    },
    {
      title: "Stage Three - Fairview Release",
      links: [
        { text: "Design Guidelines", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/01_Design_Guidelines.pdf" },
        { text: "Fairview Release One", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/02_Fairview_Release_One.pdf" },
        { text: "Fairview Release Two", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/03_Fairview_Release_Two.pdf" },
        { text: "Disclosure Plans", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/04_Disclosure_Plans.pdf" },
        { text: "Road Traffic Noise Impact Assessment", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/05_Road_Traffic_Noise_Impact_Assessment.pdf" },
        { text: "Acoustics Report Sep 2016", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/06_Acoustics_Report_Sep_2016.pdf" },
        { text: "Earthworks Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/07_Earthworks_Plan.pdf" },
        { text: "Neighbourhood Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/08_Neighbourhood_Plan.pdf" },
        { text: "Stage 3 Geotechnical Report", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/09_Stage_3_Geotechnical_Report.pdf" },
        { text: "Ridgeview Release Disclosure Plans", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/10_Ridgeview_Release_Disclosure_Plans.pdf" },
        { text: "Plan of Subdivision", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/11_Plan_of_Subdivision.pdf" },
        { text: "Bushfire Report", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/12_Bushfire_Report.pdf" },
        { text: "Registered Deposited Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/13_Registered_Deposited_Plan.pdf" },
        { text: "As Constructed Drawings", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/14_As_Constructed_Drawings.pdf" },
        { text: "Letter of Advice", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Three_-_Fairview_Release/15_Letter_of_Advice.pdf" }
      ]
    },
    {
      title: "Stage Four - Ridgeline Release One",
      links: [
        { text: "Design Guidelines", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/01_Design_Guidelines.pdf" },
        { text: "Disclosure Plans (Issue B)", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/02_Disclosure_Plans_Issue_B.pdf" },
        { text: "Neighbourhood Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/03_Neighbourhood_Plan.pdf" },
        { text: "Street Frontage Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/04_Street_Frontage_Map.pdf" },
        { text: "Lot Frontages Type Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/05_Lot_Frontages_Type_Map.pdf" },
        { text: "Acoustic Treatment Layout", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/06_Acoustic_Treatment_Layout.pdf" },
        { text: "Acoustics Report Sep 2016", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/07_Acoustics_Report_Sep_2016.pdf" },
        { text: "Mosquito Overlay Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/08_Mosquito_Overlay_Map.pdf" },
        { text: "Disclosure Plans", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/09_Disclosure_Plans.pdf" },
        { text: "Bush Fire Overlay Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/10_Bush_Fire_Overlay_Map.pdf" },
        { text: "Ridgeview Release Disclosure Plans", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/11_Ridgeview_Release_Disclosure_Plans.pdf" },
        { text: "Report on Earthworks Inspection & Testing Level 1", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/12_Report_on_Earthworks_Inspection_Testing_Level_1.pdf" },
        { text: "Deposited Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/13_Deposited_Plan.pdf" },
        { text: "Letter of Advice", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Four_-_Ridgeline_Release_One/14_Letter_of_Advice.pdf" }
      ]
    },
    {
      title: "Stages Three & Four - Ridgeview Release",
      links: [
        { text: "Neighbourhood Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/01_Neighbourhood_Plan.pdf" },
        { text: "Road Frontages Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/02_Road_Frontages_Map.pdf" },
        { text: "Lot Frontage Types Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/03_Lot_Frontage_Types_Map.pdf" },
        { text: "Bushfire Hazard Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/04_Bushfire_Hazard_Map.pdf" },
        { text: "Acoustic Control Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/05_Acoustic_Control_Map.pdf" },
        { text: "Mosquito Treatments Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/06_Mosquito_Treatments_Map.pdf" },
        { text: "Design Guidelines", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/07_Design_Guidelines.pdf" },
        { text: "As Constructed Drawings", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/08-WAE-STAGE-3-4-BANYAN-HILL-A.pdf" },
        { text: "Disclosure Plans", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/09_Disclosure_Plans.pdf" },
        { text: "Deposited Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stages_Three_Four_-_Ridgeview_Release/10_Deposited_Plan.pdf" }
      ]
    },
    {
      title: "Stage Five - Orchard Release",
      links: [
        { text: "Design Guidelines", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/01_Design_Guidelines.pdf" },
        { text: "Disclosure Plans (Lots 501 - 526)", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/02_Disclosure_Plans_Lots_501_-_526.pdf" },
        { text: "Stage Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/03_Stage_Plan.pdf" },
        { text: "Road Frontages Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/04_Road_Frontages_Map.pdf" },
        { text: "Lot Frontage Types Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/05_Lot_Frontage_Types_Map.pdf" },
        { text: "Bushfire Hazard Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/06_Bushfire_Hazard_Map.pdf" },
        { text: "Mosquito Treatments Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/07_Mosquito_Treatments_Map.pdf" },
        { text: "Neighbourhood Plan Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/08_Neighbourhood_Plan_Map.pdf" },
        { text: "Bushfire Overlay", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/09_Bushfire_Overlay.pdf" },
        { text: "Acoustics Control Map", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/10_Acoustics_Control_Map.pdf" },
        { text: "As Constructed Drawings", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/11_As_Constructed_Drawings.pdf" },
        { text: "Level 1 Earthworks Report", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/12_Level_1_Earthworks_Report.pdf" },
        { text: "Attachment K DP Report for Earthworks", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/13_Attachment_K_DP_Report_for_Earthworks.pdf" },
        { text: "Sales Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/14_Sales_Plan.pdf" },
        { text: "Deposited Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/15_Deposited_Plan.pdf" },
        { text: "Letter of Advice", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Five_-_Orchard_Release/16_Letter_of_Advice.pdf" }
      ]
    },
    {
      title: "Stage Six - Crestbury Release",
      links: [
        { text: "Design Guidelines", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Six_-_Crestbury_Release/01_Design_Guidelines.pdf" },
        { text: "Disclosure Plans (Lots 601 - 611)", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Six_-_Crestbury_Release/02_Disclosure_Plans_Lots_601_-_611.pdf" },
        { text: "Disclosure Plans (Lots 612 - 615) Northern side", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Six_-_Crestbury_Release/03_Disclosure_Plans_Lots_612_-_615_Northern_side.pdf" },
        { text: "As Constructed Drawings", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Six_-_Crestbury_Release/04_As_Constructed_Drawings.pdf" },
        { text: "Attachment T DP Report for Earthworks", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Six_-_Crestbury_Release/05_Attachment_T_DP_Report_for_Earthworks.pdf" },
        { text: "Letter of Advice", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Six_-_Crestbury_Release/06_Letter_of_Advice.pdf" }
      ]
    },
    {
      title: "Stage Ten - Hedgerow Release",
      links: [
        { text: "Design Guidelines - Inc. Neighbourhood Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/Banyan_Hill__Design_Guidelines_STAGE_10_.pdf" },
        { text: "Stage Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/Stage_Plan_Banyan_Hill_Stage_Ten.pdf" },
        {
          text: "Disclosure Plans - Stage 10B",
          url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/All Lots (Sales Plans - Stage 10B).pdf",
          inlineLinks: [
            { text: "1024", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1024 Disclosure Plan.pdf" },
            { text: "1025", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1025 Disclosure Plan.pdf" },
            { text: "1026", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1026 Disclosure Plan.pdf" },
            { text: "1027", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1027 Disclosure Plan.pdf" },
            { text: "1028", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1028 Disclosure Plan.pdf" },
            { text: "1029", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1029 Disclosure Plan.pdf" },
            { text: "1031", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1031 Disclosure Plan.pdf" },
            { text: "1032", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1032 Disclosure Plan.pdf" },
            { text: "1033", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1033 Disclosure Plan.pdf" },
            { text: "1034", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1034 Disclosure Plan.pdf" },
            { text: "1035", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1035 Disclosure Plan.pdf" },
            { text: "1036", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1036 Disclosure Plan.pdf" },
            { text: "1037", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10b/Lot 1037 Disclosure Plan.pdf" },
            { text: "1041", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1041 Disclosure.pdf" },
            { text: "1042", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1042 Disclosure.pdf" },
            { text: "1043", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1043 Disclosure.pdf" },
            { text: "1044", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1044 Disclosure.pdf" },
            { text: "1049", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1049 Disclosure.pdf" },
            { text: "1050", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1050 Disclosure.pdf" },
            { text: "1051", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1051 Disclosure.pdf" },
            { text: "1052", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1052 Disclosure.pdf" },
            { text: "1053", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1053 Disclosure.pdf" },
            { text: "1054", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1054 Disclosure.pdf" },
            { text: "1055", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/DisclosurePlans/10a/Lot 1055 Disclosure.pdf" }
          ]
        },
        { text: "Subdivision Plan", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Stage_Ten_-_Havensview_Release/Subdivisional_Layout_Banyan_Hill_Stage_10_and_11.pdf" }
      ]
    },
    // {
    //   title: "Performance Rebate",
    //   links: [
    //     { text: "Performance Rebate Application PDF", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Performance_Rebate/01_Performance_Rebate_Application_PDF.pdf" }
    //   ]
    // },
    {
      title: "Masterplan",
      links: [
        { text: "Masterplan with Street Names", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/Masterplan/01_Masterplan_with_Street_Names.pdf" }
      ]
    },
    {
      title: "General Estate Documents",
      links: [
        { text: "Bush Fire Report", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/General_Estate_Documents/01_Bush_Fire_Report.pdf" },
        { text: "Mosquito Management", url: "https://s3.intrapac.io/banyan-hill-pdf-files/pdfs/General_Estate_Documents/02_Mosquito_Management.pdf" }
      ]
    }
  ];

  return (
    <>
      <Banner
        title={'Building Resources'}
        bgImage='bg-building-resources-banner'
      />

      <div className="container mx-auto py-16 px-4 md:px-8">
        {!isAuthenticated ? (
          <div className="max-w-md mx-auto p-8">
            <h2 className="text-3xl font-tobias font-semibold text-gableGreen mb-6">Building Resources Portal</h2>
            <p className="mb-6 text-gray-600">
              Please enter the password to access the Building Resources portal.
            </p>

            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4" role="alert">
                <span className="block sm:inline">{error}</span>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="appearance-none border rounded-full w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  placeholder="Enter password"
                  required
                />
              </div>
              <button
                type="submit"
                disabled={isLoading}
                className="bg-gableGreen hover:bg-green-800 text-white font-bold py-2 px-4 rounded-full focus:outline-none focus:shadow-outline w-full flex justify-center items-center"
              >
                {isLoading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Logging in...
                  </>
                ) : (
                  'Login'
                )}
              </button>
            </form>
          </div>
        ) : (
          <div>
            <div className="mb-10 text-center">
              <h2 className="text-4xl font-tobias font-bold mb-4 text-gableGreen">Banyan Hill Building Resources</h2>
              <p className="max-w-2xl mx-auto text-gray-600">
                You can access and download stage information by clicking on the links below.
                If you have any queries, please contact the Banyan Hill sales team on <a href="tel:+611300326197" className="text-blue-600 hover:underline">1300 326 197</a>.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {buildingResources.map((section, index) => (
                <div key={index} className="h-full flex">
                  <ResourcesSection
                    title={section.title}
                    links={section.links}
                  />
                </div>
              ))}
            </div>

            <div className="mt-10 text-center">
              <p className="text-sm text-gray-500">
                © Banyan Hill {new Date().getFullYear()} - Building Resources Portal
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BuildingResources;